<template>
  <waterfall :col="col" :width="width" :gutterWidth="grap" :data="data" @scroll="scroll" ref="waterfall"
    @finish="finished" :isTransition="false" :style="{width: `${containerWidth}px,margin: 0 auto`, padding: 0}">
    <template>
      <div class="imgItems" v-for="item in data" :key="item.id">
        <div class="img-container">
          <hotConcept v-if="item.isTop == 1" :data="item.hotConcept" :type="'pc'"></hotConcept>
          <!-- <hotConcept  v-if="item.isTop" :data="item.hotConcept" :type="'mobile'"></hotConcept> -->
          <div class="imgTop" v-if="item.isTop == 1"></div>
          <div class="zhe" @click.self="showDetail(item)"></div>
          <div class="img">
            <img :src="item.thumbnailUrl" :realUrl="item.url" alt="" srcset="" />
            <!-- <img src="~@/assets/images/demo/1@2x.png" :realUrl="item.url" alt="" srcset="" /> -->
          </div>
          <div class="download" @click="downImg(item)"></div>
          <div :class="{collect: true, hasCollect: item.collectStatus === 1, button: true}"
            @click="collectChange(item.id)">
            <div class="icon"></div>
            <div class="text">
              {{ item.collectStatus === 1 ? $t('934ebd87e6') : item.collectNum == 0 ? $t('ae336cd047') : item.collectNum }}
            </div>
          </div>
          <div class="introduce">
            {{ item.content }}
          </div>
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="time"> {{ item.imgDate }}</div>
      </div>
    </template>
  </waterfall>
</template>
<script>
import { debounce } from '@/common';
import hotConcept from '@/components/hotConcept'

export default {
  components: {
    hotConcept
  },
  data() {
    return {
      width: 240,
      grap: 24,
      col: 7,
      containerWidth: 1920,
      loadDistance: 300,
      finish: false,
      // loadDistance: 100,
    };
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    type: {
      type: Number,
      default: 1,
    },
    recommend: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Number,
      default: 0,
    },
    content: {
      type: String,
      default: '',
    },
    slideId: {
      type: String,
      default: '',
    },
  },
  inject: ['group'],
  watch: {
    data(newValue, oldValue) {
      this.finish = false;
      let ids = newValue.map(d => d.id);
      this.ids = ids;
      this.$store.commit('setIds', ids);
    },
  },
  methods: {
    finished() {
      this.finish = true;
      console.log('finish');
      window.scrollTo(0, this.top);
    },
    showDetail(item) {
      let id = item.id
      if (!this.finish) {
        return;
      }
      if (!this.recommend) {
        this.$Talog({
          id: 'iFinD_news_tssj_tupian.dj',
          keyword: item.title
        });
      } else {
        this.$Talog({
          id: 'iFinD_news_tssj_tupian.tuijiantupian',
          keyword: item.title
        });
      }
      if (this.type == 4) {
        this.$parent.data = null;
        this.$parent.id = id;
        this.$parent.changeSlideId = false;
        this.$parent.content = '';
        this.$parent.renderView();
      } else {
        let change = this.type !== 4;
        this.$router.push(
          `/dataDetail?id=${id}&type=${this.type}&content=${
            this.content
          }&group=${this.group()}&slideId=${id}&change=${change}`
        );
      }
      // this.$Bus.$emit('showDetail', +id, this.type, this.data);
    },
    // loadMore() {
    //   console.log('loadmore');
    //   if (this.type == 1) {
    //     this.$Bus.$emit('loadMore');
    //   } else if (this.type == 2) {
    //     this.$Bus.$emit('collect-loadMore');
    //   } else {
    //     this.$Bus.$emit('detail-loadMore');
    //   }
    // },
    scroll(scrollData) {
      let container = document.querySelector('.d-container');
      let toolbar = document.querySelector('.d-toolbar');
      let hide = document.querySelector('.d-hide');
      if (container && toolbar && hide) {
        if (scrollData?.scrollTop > container?.clientHeight + 24 - 74) {
          toolbar.style.top = 0;
        } else {
          let top = scrollData?.scrollTop - 24;
          if (top < 0) {
            top = 0;
          }
          toolbar.style.top = `${top}px`;
        }
      }
    },
    downImg(item) {
      if (this.type == 2) {
        this.$Bus.$emit('collect-downImg', item);
      } else {
        this.$Bus.$emit('downImg', item);
      }
    },
    collectChange(id) {
      if (this.type == 4) {
        this.$parent.doCollect(id);
      } else {
        this.$parent.id = id;
        this.$parent.doCollect();
      }
    },
    render() {
      let num = Math.floor(document.body.clientWidth / 264);
      this.containerWidth = num * 240 + (num - 1) * 24;
      this.$Bus.$emit('updateLineWidth', this.containerWidth);
      this.col = num;
      this.$nextTick(() => {
        let dom = document.querySelectorAll('.vue-waterfall');
        for (let index = 0; index < dom.length; index++) {
          const element = dom[index];
          if (element) {
            element.style.width = this.containerWidth + 'px';
            element.style.margin = '0 auto';
          }
        }
      });
      this.$nextTick(() => {
        let dom = document.querySelector('.pc.dataImage');
        let group = document.querySelector('.group-wrapper');
        if(dom && group){
          dom.style.paddingTop = 68 + group.clientHeight + 'px';
        }
      });
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.render();
    });
    // this.$Bus.$on('scrollEnd',()=>{
    //   this.loadMore()
    // })
    this.render();
  },
};
</script>
<style lang="less" scoped>
.imgContainer {
  margin: 0 auto;
}
.imgItems {
  width: 240px;
  display: inline-block;
  margin-bottom: 24px;
  .img-container {
    max-height: 670px;
    min-height: 100px;
    overflow: hidden;
    border-radius: 12px;
    position: relative;
    .imgTop {
      position: absolute;
      top: 0;
      left: 0;
      width: 36px;
      height: 36px;
      background: url(~@/assets/images/top.svg) 100% 100%;
      background-size: 100% 100%;
    }
    &:hover .zhe {
      display: inline-block;
      cursor: url(~@/assets/images/expend.svg), pointer;
    }
    &:hover .download {
      display: inline-block;
    }
    &:hover .collect {
      display: flex;
    }
    &:hover .introduce {
      display: -webkit-box;
      color: #ffffff;
    }
    .img {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      img {
        max-width: 100%;
      }
    }
    .download {
      width: 32px;
      height: 32px;
      top: 16px;
      left: 16px;
      background: url(~@/assets/images/down.svg) no-repeat 100% 100%;
      background-position: center;
      position: absolute;
      z-index: 998;
      // background-color: #fefeff;
      border-radius: 8px;
      cursor: pointer;
      display: none;
      &:hover {
        background: url(~@/assets/images/down_hover.svg) no-repeat 100% 100%;
        // background-color: #ffffff;
      }
    }
    .collect {
      padding: 0 10px;
      height: 32px;
      background: #1b63d9;
      border-radius: 8px;
      top: 16px;
      right: 16px;
      position: absolute;
      z-index: 998;
      cursor: pointer;
      display: none;
      justify-content: center;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url(~@/assets/images/star.svg) no-repeat 100% 100%;
      }
      .text {
        font-size: 14px;
        color: #ffffff;
        line-height: 32px;
      }
      &:hover {
        background: #3c79de;
      }
      &:hover .star {
        background: url(~@/assets/images/star-hover.svg) no-repeat 100% 100%;
      }
    }
    .hasCollect {
      background: #4a4b72;
      &:hover {
        background: #757699;
      }
    }
    .introduce {
      font-family: Microsoft YaHei;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: 400;
      position: absolute;
      left: 15px;
      bottom: 15px;
      width: calc(100% - 30px);
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
      -webkit-box-orient: vertical;
      display: none;
      z-index: 999;
      animation: wenzi 0.3s;
    }
  }
  .title {
    font-family: Microsoft YaHei;
    font-size: 14px;
    color: #474762;
    letter-spacing: 0;
    font-weight: 400;
    padding: 0 8px;
    margin-top: 8px;
  }
  .time {
    font-family: ArialMT;
    font-size: 14px;
    color: #7D7D94;
    letter-spacing: 0;
    line-height: 14px;
    font-weight: 400;
    margin-top: 6px;
    padding: 0 8px;
  }
}
.zhe {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  z-index: 998;
  display: none;
  animation: zhezhao 0.3s;
}
@keyframes zhezhao {
  from {
    background: transparent;
  }
  to {
    background: rgba(0, 0, 0, 0.5);
  }
}
@keyframes wenzi {
  from {
    display: none;
  }
  to {
    display: block;
  }
}
/deep/ .img_viewer {
  background: #0f0f0f !important;
}
</style>
